import { BaseProps, Dialog, DialogBody, DialogTitle } from '@/components/base/dialog'
import { Form as NewForm } from './new_form'

interface Props extends BaseProps {
  eventId: string
}

export const NewDialog = ({ eventId, open, setOpen }: Props) => {
  return (
    <>
      <Dialog open={open} size="3xl" onClose={setOpen}>
        <DialogTitle>New stage</DialogTitle>
        <DialogBody>
          <NewForm eventId={eventId} onSuccess={() => setOpen(false)} />
        </DialogBody>
      </Dialog>
    </>
  )
}
